<template>
  <div>
    <el-dialog
        :title="$t('text.atUserIdAdd')"
        :visible.sync="dialogShow"
        width="600px"
        append-to-body
        @close="closeDialog"
    >
      <el-form :model="form" ref="userForm" :rules="rules" label-width="120px">
        <el-form-item :label="$t('text.larkLoginUserName')" prop="queryValue">
          <el-input v-model="form.queryValue" :placeholder="$t('text.larkLoginPhoneOrEmail')">
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('text.displayName')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('message.inputName')"/>
        </el-form-item>

        <el-form-item :label="$t('text.groupName')" prop="role">
          <el-select v-model="form.role" filterable clearable allow-create style="width: 100%">
            <el-option v-for="item in roleList" :key="item" :label="item" :value="item"/>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.tgUserId')">
          <TgUserIdField v-model="form.tgUserId"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" :loading="loading" @click="handleInsert">
          {{ $t('text.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TgUserIdField from "@/views/developer/components/messagingAppAt/TgUserIdField.vue";

export default {
  components: {TgUserIdField},
  props: {
    show: {type: Boolean, default: false},
    roleList: {type: Array, default: () => []},
    appUserInfo: {type: Array, default: () => []},
  },
  data() {
    return {
      dialogShow: false,
      showUserInfoList: false,
      isFetching: false,
      loading: false,
      form: {
        queryValue: '',
        userId: '',
        tgUserId: '',
        name: '',
        role: ''
      },
      rules: {
        queryValue: [{required: true, message: this.$t('message.input'), trigger: 'blur'}],
        name: [{required: true, message: this.$t('message.input'), trigger: 'blur'}],
        role: [{required: true, message: this.$t('message.input'), trigger: 'change'}]
      }
    };
  },
  computed: {
    canSubmit() {
      return !!(this.form.userId && this.form.name && this.form.role);
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.dialogShow = newVal;
        if (newVal) {
          this.$nextTick(() => {
            if (this.$refs.userForm) this.$refs.userForm.resetFields();
            this.form.userId = '';
            this.form.tgUserId = '';
          });
        }
      }
    }
  },
  methods: {
    handleInsert() {
      this.$refs.userForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;

        this.axios.post("/messagingAppUserInfo/add", this.form).then((res) => {
          if (res.code === 200) {
            this.$notify({
              title: this.$t('text.success'),
              message: res.msg,
              type: "success",
            });

            this.$bus.$emit("refresh"); //通知刷新
            this.$emit('update-messaging-user-info');

            this.closeDialog();
          } else {
            this.$notify.error({
              title: this.$t('text.error'),
              message: res.msg,
            });
          }
        });
        this.loading = false;
      });
    },
    closeDialog() {
      this.$emit("update:show", false);
    },
  },
};
</script>
